import {$$} from '../../utils';
import * as footerMobileCss from '../footer/mobile.scss';

export function removeHiddenClassHackForEditorsSites() {
  const classToRemove = 'hiddenTillReady';
  const footerIdToExclude = 'SITE_FOOTER';

  const hidingElement = $$('footer').find(footer => !footer.id.includes(footerIdToExclude)).closest(`.${classToRemove}`);

  if (hidingElement) {
    hidingElement.classList.remove(classToRemove);
    hidingElement.style.display = 'block';
  }

  return this;
}

export function removeAttributeFromLinks() {
  $$(`.${footerMobileCss.container} a`).forEach(link => link.setAttribute('target', ''));
  return this;
}
